/** Shared design language for CSS overlays and Three.js materials. */

export const colors = {
  ink: "#090A0A",
  paper: "#F1EFE8",
  gray: "#B8B8B0",
  darkGray: "#222422",
  signal: "#D6FF3F",
  metal: "#C8C4B8",
  metalDark: "#2E302C",
  metalMid: "#8A8880",
};

export const threeColors = {
  ink: colors.ink,
  paper: colors.paper,
  gray: colors.gray,
  darkGray: colors.darkGray,
  signal: colors.signal,
  metal: colors.metal,
  metalDark: colors.metalDark,
  metalMid: colors.metalMid,
};

export const fonts = {
  display: '"Bebas Neue", "Arial Narrow", sans-serif',
  ui: '"Sora", system-ui, sans-serif',
};
